export const influencerProfile = {
  id: "INF-20250001",
  name: "好物猎人雨姐",
  avatar: "https://public.readdy.ai/ai/img_res/7873b840ba85f80b0c6aaf5fb150a3e7.jpg",
  platforms: [
    { name: "抖音", icon: "ri-tiktok-line", handle: "@好物猎人雨姐", followers: "128万", color: "bg-gray-900" },
    { name: "微信视频号", icon: "ri-wechat-line", handle: "@雨姐精选好物", followers: "56万", color: "bg-green-600" },
    { name: "TikTok", icon: "ri-tiktok-line", handle: "@YuJieFinds", followers: "89万", color: "bg-gray-800" },
    { name: "YouTube", icon: "ri-youtube-line", handle: "@YuJieLifestyle", followers: "34万", color: "bg-red-600" },
  ],
  joinDate: "2025-08-15",
  level: "金牌达人",
  levelIcon: "ri-vip-crown-line",
  totalEarnings: 68420,
  monthEarnings: 12380,
  pendingPayout: 4560,
  totalOrders: 2847,
  monthOrders: 312,
  conversionRate: 8.4,
};

export const factoryPartners = [
  {
    id: "FAC-001",
    name: "深圳华强电子科技有限公司",
    category: "手机数码",
    logo: "https://readdy.ai/api/search-image?query=modern%20electronics%20technology%20company%20logo%20icon%20on%20clean%20white%20background%2C%20professional%20corporate%20branding%2C%20minimalist%20design%2C%20circuit%20board%20motif&width=80&height=80&seq=fac1&orientation=squarish",
    commissionRate: 8,
    products: 24,
    totalSales: 1240,
    myEarnings: 18600,
    status: "合作中",
    warehouseCity: "深圳",
    shippingTime: "24小时发货",
    brand: "华强数码",
  },
  {
    id: "FAC-002",
    name: "广州美妆集团股份有限公司",
    category: "美妆护肤",
    logo: "https://readdy.ai/api/search-image?query=beauty%20cosmetics%20brand%20logo%20icon%20on%20clean%20white%20background%2C%20professional%20corporate%20branding%2C%20minimalist%20elegant%20design%2C%20flower%20petal%20motif&width=80&height=80&seq=fac2&orientation=squarish",
    commissionRate: 15,
    products: 38,
    totalSales: 890,
    myEarnings: 22400,
    status: "合作中",
    warehouseCity: "广州",
    shippingTime: "48小时发货",
    brand: "美颜集",
  },
  {
    id: "FAC-003",
    name: "杭州时尚服饰制造有限公司",
    category: "服装鞋包",
    logo: "https://readdy.ai/api/search-image?query=fashion%20clothing%20brand%20logo%20icon%20on%20clean%20white%20background%2C%20professional%20corporate%20branding%2C%20minimalist%20stylish%20design%2C%20hanger%20motif&width=80&height=80&seq=fac3&orientation=squarish",
    commissionRate: 12,
    products: 56,
    totalSales: 2100,
    myEarnings: 15800,
    status: "合作中",
    warehouseCity: "杭州",
    shippingTime: "24小时发货",
    brand: "杭韵时尚",
  },
  {
    id: "FAC-004",
    name: "佛山家居用品制造厂",
    category: "家居家具",
    logo: "https://readdy.ai/api/search-image?query=home%20furniture%20brand%20logo%20icon%20on%20clean%20white%20background%2C%20professional%20corporate%20branding%2C%20minimalist%20modern%20design%2C%20house%20motif&width=80&height=80&seq=fac4&orientation=squarish",
    commissionRate: 10,
    products: 18,
    totalSales: 430,
    myEarnings: 8200,
    status: "合作中",
    warehouseCity: "佛山",
    shippingTime: "72小时发货",
    brand: "佛山优居",
  },
  {
    id: "FAC-005",
    name: "义乌小商品贸易有限公司",
    category: "母婴玩具",
    logo: "https://readdy.ai/api/search-image?query=baby%20toys%20brand%20logo%20icon%20on%20clean%20white%20background%2C%20professional%20corporate%20branding%2C%20minimalist%20cute%20design%2C%20star%20motif&width=80&height=80&seq=fac5&orientation=squarish",
    commissionRate: 18,
    products: 72,
    totalSales: 3200,
    myEarnings: 3420,
    status: "待审核",
    warehouseCity: "义乌",
    shippingTime: "24小时发货",
    brand: "义乌优品",
  },
];

export const salesRecords = [
  {
    id: "ORD-20260401-001",
    date: "2026-04-10",
    platform: "抖音",
    platformIcon: "ri-tiktok-line",
    platformColor: "bg-gray-900",
    product: "华强数码 无线蓝牙耳机 Pro",
    productImage: "https://readdy.ai/api/search-image?query=wireless%20bluetooth%20earbuds%20premium%20product%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=80&height=80&seq=sale1&orientation=squarish",
    factory: "深圳华强电子科技有限公司",
    factoryId: "FAC-001",
    orderAmount: 299,
    commissionRate: 8,
    commission: 23.92,
    status: "已结算",
    buyer: "用户****8821",
    warehouseCity: "深圳",
  },
  {
    id: "ORD-20260401-002",
    date: "2026-04-10",
    platform: "TikTok",
    platformIcon: "ri-tiktok-line",
    platformColor: "bg-gray-800",
    product: "美颜集 玻尿酸精华液 50ml",
    productImage: "https://readdy.ai/api/search-image?query=hyaluronic%20acid%20serum%20skincare%20bottle%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=80&height=80&seq=sale2&orientation=squarish",
    factory: "广州美妆集团股份有限公司",
    factoryId: "FAC-002",
    orderAmount: 388,
    commissionRate: 15,
    commission: 58.2,
    status: "已结算",
    buyer: "用户****3341",
    warehouseCity: "广州",
  },
  {
    id: "ORD-20260401-003",
    date: "2026-04-09",
    platform: "YouTube",
    platformIcon: "ri-youtube-line",
    platformColor: "bg-red-600",
    product: "杭韵时尚 法式碎花连衣裙",
    productImage: "https://readdy.ai/api/search-image?query=French%20floral%20dress%20fashion%20clothing%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=80&height=80&seq=sale3&orientation=squarish",
    factory: "杭州时尚服饰制造有限公司",
    factoryId: "FAC-003",
    orderAmount: 299,
    commissionRate: 12,
    commission: 35.88,
    status: "已结算",
    buyer: "用户****7712",
    warehouseCity: "杭州",
  },
  {
    id: "ORD-20260401-004",
    date: "2026-04-09",
    platform: "微信视频号",
    platformIcon: "ri-wechat-line",
    platformColor: "bg-green-600",
    product: "美颜集 防晒霜 SPF50+ 50g",
    productImage: "https://readdy.ai/api/search-image?query=sunscreen%20SPF50%20skincare%20tube%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=80&height=80&seq=sale4&orientation=squarish",
    factory: "广州美妆集团股份有限公司",
    factoryId: "FAC-002",
    orderAmount: 168,
    commissionRate: 15,
    commission: 25.2,
    status: "已结算",
    buyer: "用户****5590",
    warehouseCity: "广州",
  },
  {
    id: "ORD-20260401-005",
    date: "2026-04-08",
    platform: "抖音",
    platformIcon: "ri-tiktok-line",
    platformColor: "bg-gray-900",
    product: "华强数码 智能手表 运动版",
    productImage: "https://readdy.ai/api/search-image?query=smart%20watch%20sports%20edition%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=80&height=80&seq=sale5&orientation=squarish",
    factory: "深圳华强电子科技有限公司",
    factoryId: "FAC-001",
    orderAmount: 599,
    commissionRate: 8,
    commission: 47.92,
    status: "待结算",
    buyer: "用户****2234",
    warehouseCity: "深圳",
  },
  {
    id: "ORD-20260401-006",
    date: "2026-04-08",
    platform: "抖音",
    platformIcon: "ri-tiktok-line",
    platformColor: "bg-gray-900",
    product: "杭韵时尚 修身西装套装",
    productImage: "https://readdy.ai/api/search-image?query=slim%20fit%20suit%20set%20fashion%20clothing%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=80&height=80&seq=sale6&orientation=squarish",
    factory: "杭州时尚服饰制造有限公司",
    factoryId: "FAC-003",
    orderAmount: 899,
    commissionRate: 12,
    commission: 107.88,
    status: "已结算",
    buyer: "用户****9981",
    warehouseCity: "杭州",
  },
  {
    id: "ORD-20260401-007",
    date: "2026-04-07",
    platform: "YouTube",
    platformIcon: "ri-youtube-line",
    platformColor: "bg-red-600",
    product: "佛山优居 北欧实木茶几",
    productImage: "https://readdy.ai/api/search-image?query=Nordic%20solid%20wood%20coffee%20table%20furniture%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=80&height=80&seq=sale7&orientation=squarish",
    factory: "佛山家居用品制造厂",
    factoryId: "FAC-004",
    orderAmount: 1299,
    commissionRate: 10,
    commission: 129.9,
    status: "已结算",
    buyer: "用户****4456",
    warehouseCity: "佛山",
  },
  {
    id: "ORD-20260401-008",
    date: "2026-04-07",
    platform: "微信视频号",
    platformIcon: "ri-wechat-line",
    platformColor: "bg-green-600",
    product: "美颜集 氨基酸洁面乳 150ml",
    productImage: "https://readdy.ai/api/search-image?query=amino%20acid%20facial%20cleanser%20skincare%20tube%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=80&height=80&seq=sale8&orientation=squarish",
    factory: "广州美妆集团股份有限公司",
    factoryId: "FAC-002",
    orderAmount: 128,
    commissionRate: 15,
    commission: 19.2,
    status: "已结算",
    buyer: "用户****7723",
    warehouseCity: "广州",
  },
  {
    id: "ORD-20260401-009",
    date: "2026-04-06",
    platform: "TikTok",
    platformIcon: "ri-tiktok-line",
    platformColor: "bg-gray-800",
    product: "华强数码 Type-C 快充数据线 3条装",
    productImage: "https://readdy.ai/api/search-image?query=USB%20Type-C%20fast%20charging%20cable%20set%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=80&height=80&seq=sale9&orientation=squarish",
    factory: "深圳华强电子科技有限公司",
    factoryId: "FAC-001",
    orderAmount: 59,
    commissionRate: 8,
    commission: 4.72,
    status: "已结算",
    buyer: "用户****3312",
    warehouseCity: "深圳",
  },
  {
    id: "ORD-20260401-010",
    date: "2026-04-05",
    platform: "抖音",
    platformIcon: "ri-tiktok-line",
    platformColor: "bg-gray-900",
    product: "杭韵时尚 羊绒混纺毛衣",
    productImage: "https://readdy.ai/api/search-image?query=cashmere%20blend%20sweater%20knitwear%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=80&height=80&seq=sale10&orientation=squarish",
    factory: "杭州时尚服饰制造有限公司",
    factoryId: "FAC-003",
    orderAmount: 359,
    commissionRate: 12,
    commission: 43.08,
    status: "已结算",
    buyer: "用户****8890",
    warehouseCity: "杭州",
  },
];

export const monthlyEarnings = [
  { month: "10月", amount: 3200, orders: 89 },
  { month: "11月", amount: 5800, orders: 156 },
  { month: "12月", amount: 9200, orders: 248 },
  { month: "1月", amount: 7600, orders: 201 },
  { month: "2月", amount: 10400, orders: 278 },
  { month: "3月", amount: 12380, orders: 312 },
];

export const platformStats = [
  { platform: "抖音", icon: "ri-tiktok-line", color: "bg-gray-900", orders: 1240, earnings: 28400, conversionRate: 9.2 },
  { platform: "TikTok", icon: "ri-tiktok-line", color: "bg-gray-700", orders: 680, earnings: 18600, conversionRate: 7.8 },
  { platform: "微信视频号", icon: "ri-wechat-line", color: "bg-green-600", orders: 520, earnings: 12800, conversionRate: 8.1 },
  { platform: "YouTube", icon: "ri-youtube-line", color: "bg-red-600", orders: 407, earnings: 8620, conversionRate: 6.5 },
];
